import { STATIC_URL } from 'constants/data'

const iconsData = {
  views: {
    path: `${STATIC_URL}/icons/icon_eye.svg`,
    alt: 'Глаз',
  },
  likes: {
    path: `${STATIC_URL}/icons/icon_like.svg`,
    alt: 'Палец вверх',
  },
}

export { iconsData }
